import 'dayjs/locale/pt-br'

import { Provider } from '@rollbar/react'
import { QueryClientProvider } from '@tanstack/react-query'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'

import { CustomErrorBoundary } from './modules/shared/components/error-boundary/custom-error-boundary'
import { rollbarConfig } from './modules/shared/infra/rollbar.config'
import { queryClient } from './modules/shared/lib/query-client'
import { router } from './modules/shared/routes'

dayjs.extend(utc)

export function App() {
	return (
		<Provider config={rollbarConfig}>
			<CustomErrorBoundary>
				<QueryClientProvider client={queryClient}>
					<RouterProvider router={router} />
					<Toaster
						richColors
						className="toaster group"
						toastOptions={{
							classNames: {
								error: '!border-none !bg-[#ffffff] !text-[#dc2626] !shadow-lg !rounded-lg',
								info: '!border-none !bg-[#ffffff] !text-[#2563eb] !shadow-lg !rounded-lg',
								loading: '!border-none !bg-[#ffffff] !text-[#374151] !shadow-lg !rounded-lg',
								success: '!border-none !bg-[#ffffff] !text-[#16a34a] !shadow-lg !rounded-lg',
								warning: '!border-none !bg-[#ffffff] !text-[#d97706] !shadow-lg !rounded-lg',
							},
							style: {
								backdropFilter: 'blur(8px)',
								border: '1px solid rgba(255, 255, 255, 0.1)',
								fontWeight: '500',
								fontSize: '14px',
								padding: '12px 16px',
								minHeight: '48px',
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
							},
						}}
						position="bottom-center"
						expand={false}
						duration={4000}
						closeButton={true}
						visibleToasts={1}
					/>
				</QueryClientProvider>
			</CustomErrorBoundary>
		</Provider>
	)
}
